import { ArrowRight, Mail, Linkedin, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const CONTACT_PHOTO = "https://customer-assets.emergentagent.com/job_tulsi-home/artifacts/w05yhz4j_2025-10_FoodHaus_DSC00212.jpg";

export function ContactSection() {
  return (
    <section id="contact" className="hm-section py-16 md:py-24" style={{ background: "var(--ink)" }} data-testid="contact-section">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row gap-12 md:gap-16">
          <div className="w-full md:w-[60%]">
            <p className="hm-mono reveal" style={{ fontSize: "0.65rem", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.18em", color: "rgba(255,255,255,0.4)" }} data-testid="contact-label">Let's connect</p>
            <h2 className="hm-display reveal reveal-d1 mt-6" style={{ fontSize: "clamp(1.5rem, 3.5vw, 1.8rem)", fontWeight: 600, fontStyle: "italic", color: "var(--white)", lineHeight: 1.3 }} data-testid="contact-headline">"Let's write the next chapter together."</h2>

            <ul className="mt-8 space-y-4" style={{ listStyle: "none", padding: 0 }}>
              <li className="flex items-center gap-3 reveal reveal-d2">
                <Mail size={18} style={{ color: "var(--green)", flexShrink: 0 }} />
                <a href="mailto:giritulsi@gmail.com" style={{ color: "var(--green)", textDecoration: "none", fontWeight: 500 }} data-testid="contact-email">giritulsi@gmail.com</a>
              </li>
              <li className="flex items-center gap-3 reveal reveal-d3">
                <Linkedin size={18} style={{ color: "rgba(255,255,255,0.6)", flexShrink: 0 }} />
                <a href="https://www.linkedin.com/in/tulsi-giri-91448517/" target="_blank" rel="noopener noreferrer" style={{ color: "rgba(255,255,255,0.8)", textDecoration: "none" }} data-testid="contact-linkedin">LinkedIn Profile</a>
              </li>
              <li className="flex items-center gap-3 reveal reveal-d4">
                <MapPin size={18} style={{ color: "rgba(255,255,255,0.6)", flexShrink: 0 }} />
                <span style={{ color: "rgba(255,255,255,0.8)" }}>Based in Nepal &#127475;&#127477;</span>
              </li>
            </ul>

            <p className="reveal reveal-d5 mt-6" style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.85rem", lineHeight: 1.6 }} data-testid="contact-note">I read every message personally. I reply within 2–3 days.</p>
            <div className="mt-8 reveal" style={{ transitionDelay: "700ms" }}>
              <a href="mailto:giritulsi@gmail.com" className="hm-btn-green" data-testid="contact-cta">Get in touch <ArrowRight size={16} /></a>
            </div>
          </div>
          <div className="w-full md:w-[40%] hidden md:flex items-center justify-center reveal reveal-d2" data-testid="contact-photo">
            <img src={CONTACT_PHOTO} alt="Tulsi Giri" style={{ borderRadius: 16, maxHeight: 400, objectFit: "cover", width: "100%", opacity: 0.85 }} />
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 mt-16 pt-6" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }} data-testid="footer-bar">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
          <p style={{ color: "rgba(255,255,255,0.25)", fontSize: "0.8rem" }}>&copy; 2026 Tulsi Giri</p>
          <div className="flex items-center gap-4" style={{ color: "rgba(255,255,255,0.25)", fontSize: "0.8rem" }}>
            <Link to="/blog" style={{ color: "inherit", textDecoration: "none" }} data-testid="footer-updates">Updates</Link>
            <Link to="/admin" style={{ color: "inherit", textDecoration: "none" }} data-testid="footer-admin">Admin</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
